// extracted by extract-css-chunks-webpack-plugin
module.exports = {"price":"wLAgH","mapLabel":"RoYXf","priceMatch":"bZ2jw","link":"AjBph","guranteeMatch":"VxSUY","sticky":"nA0-V","promotionalLabel":"oysVP"};